import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './DJDUVSearch.css';

function DJDUVSearch({ tableData }) {
    return (
        <div className="DJDUV_search-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No se encontraron resultados para DJDUV</h4>
            )}
        </div>
    );
}

export default DJDUVSearch;
